import {
  Button,
  Grid,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material";
import { Box } from "@mui/system";
import { formStyles } from "./styles";
import { useState, useMemo, useEffect } from "react";
import { POST_API_CALL } from "utils/services";
import { ENDPOINTS } from "utils/endpoints";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_NAMES from "routes/routeNames";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCities,
  // getAllCongregationByCity,
  // getAllStates,
  updateCongregation,
} from "modules/congregation/action";
import moment from "moment";
import { ReducersModal } from "utils/modals";
import { congregationRequestStatus } from "modules/requestCongregation/action";
import CustomModal from "components/customModal";

export const CongregationForm = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();
  const dispatch: Function = useDispatch();
  const location = useLocation();
  const modalClose = () => {
    setModal(false);
  };
  const isRequested = props.isRequested;
  const congrigationResult = useSelector((store: any) =>
    isRequested
      ? store.CongregationReducer?.requestCongregation?.result
      : store.CongregationReducer?.congregations?.result
  );

  const { allStates, allCities } = useSelector(
    (store: any) => store.CongregationReducer?.congregations
  );

  let congregationId = location?.state?.id;

  const defaultValues = useMemo(() => {
    const index = congrigationResult.findIndex(
      (item: any) => item.id == congregationId
    );
    if (index != -1) {
      return congrigationResult[index];
    }
    return {
      city: "",
      id: -1,
      name: "",
      state: "",
      zipcode: "",
      latitude: "",
      longitude: "",
    };
  }, [congrigationResult]);

  const [formValue, setFormValue] = useState({
    ...defaultValues,
  });

  useEffect(() => {
    const index = congrigationResult.findIndex(
      (item: any) => item.id == congregationId
    );

    index != -1 &&
      dispatch(
        getAllCities({
          data: { id: congrigationResult[index].stateId, search: "" },
        })
      );
  }, []);

  const onHandleRequest = (status: string) => {
    if (isRequested) {
      const payload = {
        id: congregationId,
        status: status,
      };
      dispatch(
        congregationRequestStatus({
          data: payload,
          callback: () => {
            navigate(ROUTE_NAMES.MAIN_ROUTES.REQUESTED_CONGREGATION);
          },
        })
      );
    } else {
      navigate(ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS);
    }
    setModal(false);
  };
  const handleSubmit = (data: Record<string, any>) => {
    // const body: Record<string, any> = {
    //   ...data,
    //   name: data.congregationName,
    // };
    // delete body.congregationName;

    console.log("data :", data);
    console.log("form value :", formValue);

    debugger;

    if (isRequested) {
      const addPayload = {
        name: formValue.name,
        cityId: formValue.cityId,
        stateId: formValue.stateId,
        zipcode: formValue.zipcode,
        latitude: formValue.latitude,
        longitude: formValue.longitude,
      };
      setIsLoading(true);
      POST_API_CALL(
        ENDPOINTS.CONGREGATIONS.ADD,
        addPayload,
        (response: any) => {
          console.log("handleSubmit", response);
          if (response.isSuccess) {
            const payload = {
              id: congregationId,
              congregationId: response.data.id,
              status: "1",
            };
            dispatch(
              congregationRequestStatus({
                data: payload,
                callback: () => {
                  navigate(ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS);
                },
              })
            );
            // navigate(ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS);
          } else {
            // show error
          }
          setIsLoading(false);
        }
      );

      return;
    }
    const body = {
      name: formValue.name,
      cityId: formValue.cityId,
      stateId: formValue.stateId,
      zipcode: formValue.zipcode,
      latitude: formValue.latitude,
      longitude: formValue.longitude,
    };
    if (!congregationId) {
      setIsLoading(true);
      POST_API_CALL(ENDPOINTS.CONGREGATIONS.ADD, body, (response: any) => {
        if (response.isSuccess) {
          navigate(ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS);
        } else {
          // show error
        }
        setIsLoading(false);
      });
    } else if (congregationId) {
      setIsLoading(true);
      dispatch(
        updateCongregation({
          data: { ...body, id: congregationId },
          callback: (response: any) => {
            if (response?.isSuccess) {
              navigate(ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS);
            } else {
            }
          },
        })
      );
      // PUT_API_CALL(ENDPOINTS.CONGREGATIONS.ADD, body, (response: any) => {
      //   if (response.isSuccess) {
      //     navigate(ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS);
      //   } else {
      //     // show error
      //   }
      //   setIsLoading(false);
      // });
    }
  };
  const renderModalBody = () => {
    return (
      <Box sx={{ padding: "1rem" }}>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "1rem",
            lineHeight: "30px",
            padding: "1rem",
          }}
        >
          {`Are you sure, want to ${isRequested ? "reject request of this user and go back " :" discard changes and go back"} ?`}
        </Typography>
        <Box
          sx={{ display: "flex", justifyContent: "space-between", px: "1rem" }}
        >
          <Button
            variant="outlined"
            color={"secondary"}
            sx={{ width: 100 }}
            onClick={() => setModal(false)}
          >
            Cancle
          </Button>
          <Button
            variant="contained"
            color={"secondary"}
            sx={{ width: 100 }}
            onClick={() => onHandleRequest("2")}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      <Typography sx={formStyles.heading} variant="h2">
        Congregation Details
      </Typography>
      {formValue?.user ? (
        <Box style={{ borderWidth: 2, borderColor: "red" }}>
          <Grid
            container
            style={{ margin: "2px", borderWidth: "2px", borderColor: "red" }}
            mt={2}
            spacing={2}
          >
            <Grid item xs={12} md={6}>
              <Typography style={{ fontWeight: "600" }}>Created By</Typography>
              <Typography style={{ marginTop: "5px" }}>
                {formValue.user.firstName + " " + formValue.user.lastName}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography style={{ fontWeight: "600" }}>Created At</Typography>
              <Typography style={{ marginTop: "5px" }}>
                {moment().format("MM/DD/YYYY")}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      ) : null}
      <Box
        my={3}
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          let data: Record<string, any> = {};
          formData.forEach((value, key) => {
            data[key] = value;
          });
          handleSubmit(data);
        }}
        defaultValue={defaultValues}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              value={formValue.name}
              onChange={(event) =>
                setFormValue((prev: any) => ({
                  ...prev,
                  name: event.target.value,
                }))
              }
              name="congregationName"
              required
              fullWidth
              id="congregationName"
              label="Official Congregation Name"
              autoFocus
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {/* <TextField
              color="secondary"
              value={formValue.state}
              required
              onChange={(event) =>
                setFormValue((prev: any) => ({
                  ...prev,
                  state: event.target.value,
                }))
              }
              fullWidth
              id="state"
              label="Congregation State"
              name="state"
            /> */}
            {/* <FormControl fullWidth>
              <InputLabel id="congregation_state">
                Congregation State
              </InputLabel>
              <Select
                sx={formStyles.selectDropdown}
                label="Congregation State"
                labelId={"congregation_state"}
                name="state"
                color="secondary"
                id="state"
                required
                native={false}
                variant="outlined"
                value={formValue.state}
                onChange={(e: any) => {
                  dispatch(
                    getAllCities({ data: { id: e.target.value, search: "ab" } })
                  );
                  setFormValue((prev: any) => ({
                    ...prev,
                    state: e.target.value,
                  }));
                }}
              >
                {allStates.result.map((item: any) => (
                  <MenuItem value={item.id}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl> */}

            <Autocomplete
              disablePortal
              id="state"
              value={formValue.state}
              onChange={(event, newValue: any) => {
                const onUpdateValue = (value: any) => {
                  console.log("onUpdateValue", value);
                  if (value) {
                    dispatch(
                      getAllCities({ data: { id: value.id, search: "" } })
                    );
                    setFormValue((prev: any) => ({
                      ...prev,
                      state: value.label,
                      stateId: value.id,
                    }));
                  }
                };
                if (typeof newValue === "string") {
                  onUpdateValue(newValue);
                } else if (newValue && newValue.inputValue) {
                  onUpdateValue(newValue.inputValue);
                } else {
                  onUpdateValue(newValue);
                }
              }}
              options={allStates.result.map((item: any) => ({
                label: item.name,
                id: item.id,
              }))}
              renderInput={(params) => (
                <TextField {...params} label="Select State" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {/* <TextField
              color="secondary"
              required
              fullWidth
              onChange={(event) =>
                setFormValue((prev: any) => ({
                  ...prev,
                  city: event.target.value,
                }))
              }
              value={formValue.city}
              id="city"
              label="Congregation City"
              name="city"
            /> */}
            {/* <FormControl fullWidth>
              <InputLabel id="congregation_city">Congregation City</InputLabel>
              <Select
                sx={formStyles.selectDropdown}
                label="Congregation State"
                labelId={"congregation_city"}
                name="city"
                color="secondary"
                id="city"
                required
                native={false}
                variant="outlined"
                value={formValue.city}
                onChange={(e: any) => {
                  setFormValue((prev: any) => ({
                    ...prev,
                    city: e.target.value,
                  }));
                  dispatch(
                    getAllCongregationByCity({
                      data: {
                        stateId: formValue.state,
                        cityId: e.target.value,
                      },
                    })
                  );
                }}
              >
                {allCities?.result?.map((item: any) => (
                  <MenuItem value={item.id}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <Autocomplete
              disablePortal
              id="city"
              value={formValue.city || ""}
              options={allCities?.result?.map(
                (item: any) =>
                  ({
                    label: item.name,
                    id: item.id,
                  } || [])
              )}
              onChange={(event, newValue: any) => {
                const onUpdateValue = (value: any) => {
                  if (value) {
                    setFormValue((prev: any) => ({
                      ...prev,
                      city: value.label,
                      cityId: value.id,
                    }));
                    // dispatch(
                    //   getAllCities({ data: { id: value.id, search: value } })
                    // );
                  }
                };
                if (typeof newValue === "string") {
                  onUpdateValue(newValue);
                } else if (newValue && newValue.inputValue) {
                  onUpdateValue(newValue.inputValue);
                } else {
                  onUpdateValue(newValue);
                }
              }}
              renderInput={(params) => (
                <TextField
                  onChange={(event: any) => {
                    dispatch(
                      getAllCities({
                        data: {
                          id: formValue.stateId,
                          search: event.target.value,
                        },
                      })
                    );
                  }}
                  {...params}
                  label="Select City"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              inputProps={{ maxLength: 5 }}
              fullWidth
              id="zipcode"
              onChange={(event) =>
                setFormValue((prev: any) => ({
                  ...prev,
                  zipcode: event.target.value,
                }))
              }
              value={formValue.zipcode}
              label="Congregation Zipcode"
              name="zipcode"
            />
          </Grid>
          {/* Latitude */}
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              error={
                parseInt(formValue.latitude) < -90 ||
                parseInt(formValue.latitude) > 90
              }
              fullWidth
              id="latitude"
              onChange={(event) =>
                setFormValue((prev: any) => ({
                  ...prev,
                  latitude: event.target.value,
                }))
              }
              value={formValue.latitude}
              type="text"
              label="Latitude"
              name="latitude"
            />
          </Grid>
          {/* Longitude */}
          <Grid item xs={12} md={6}>
            <TextField
              color="secondary"
              required
              error={
                parseInt(formValue.longitude) < -180 ||
                parseInt(formValue.longitude) > 180
              }
              fullWidth
              id="longitude"
              onChange={(event) =>
                setFormValue((prev: any) => ({
                  ...prev,
                  longitude: event.target.value,
                }))
              }
              value={formValue.longitude}
              type="text"
              label="Longitude"
              name="longitude"
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" gap={2}>
              <Button
                onClick={() => setModal(true)}
                variant="outlined"
                color={isRequested ? "error" : "secondary"}
                disabled={isLoading}
                sx={{ mt: 3, mb: 2, width: 200 }}
              >
                {isRequested ? "Reject" : "Cancel"}
              </Button>
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isLoading}
                sx={{ mt: 3, mb: 2, width: 200 }}
              >
                {isRequested ? "Approve" : congregationId ? "Update" : "Create"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <CustomModal
        title={"Congregation"}
        children={renderModalBody()}
        visible={modal}
        onClose={modalClose}
      />
    </Box>
  );
};
